import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Card } from '@atoms/Card';
import { formatCurrency } from '@utils/formatters';
import type { ChartPoint } from '@/types';

interface SalesChartProps {
  data: ChartPoint[];
  title?: string;
  valueLabel?: string;
  subtitle?: string;
}

export function SalesChart({ data, title = 'Son 7 Gün', valueLabel = 'Tutar', subtitle }: SalesChartProps) {
  const chartData = data.map((p) => ({
    ...p,
    label: p.date.slice(5),
  }));

  return (
    <Card>
      <h3 className="mb-1 font-medium text-gray-900">{title}</h3>
      {subtitle ? <p className="mb-4 text-xs text-gray-500">{subtitle}</p> : <div className="mb-4" />}
      {chartData.every((p) => p.total === 0) ? (
        <p className="py-8 text-center text-sm text-gray-500">Bu dönemde veri yok</p>
      ) : (
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => `${Math.round(v / 1000)}k`} />
              <Tooltip formatter={(value) => [formatCurrency(Number(value ?? 0)), valueLabel]} />
              <Line type="monotone" dataKey="total" stroke="#ff6b00" strokeWidth={2} dot />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
